import React, { useEffect, useLayoutEffect } from 'react';
import {useQuery} from '@apollo/client';
import Query from '../../components/Query';
import {QUERY_CONTEST_LIST} from './graphql';
import moment from 'moment';
import {Tooltip} from 'bootstrap';

const ContestList = ({history, match}) => {
  const query = useQuery(QUERY_CONTEST_LIST);

  useEffect(() => {
    setTimeout(() => {
      var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
      var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new Tooltip(tooltipTriggerEl);
      })
    }, [500]);
  }, []);

  return (
    <div className="container">
      {Query(query) || (
        <div className="row g-2 g-md-4 py-4">
          {query.data.contestList.map(item => (
            <div key={item.id} className="col-6 col-md-4 col-lg-3">
              <div className="pt-4 pb-2 px-2 border rounded bg-white font-2">
                <div className="text-center">{moment(item.startTime).format('DD MMM YYYY')}</div>
                <div className="text-center text-muted font-1">
                  {moment(item.startTime).format('HH:mm:ss')} - {moment(item.endTime).format('HH:mm:ss')}
                </div>
                <div className="text-center my-3 font-4">{item.name}</div>
                <div
                  className="ratio ratio-16x9 bg-white rounded bg mb-3"
                  style={{backgroundSize: 'cover', backgroundImage: `url(${item.cover.path})`}}
                />
                <div className="row g-3 my-4">
                  <div className="col">
                    {moment().isBefore(moment(item.startTime)) ? (
                      <div
                        className="btn btn-primary w-100"
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        data-bs-original-title={`Будет доступен с ${moment(item.startTime).format('HH:mm')}`}
                        data-delay="0"
                      >
                        {moment().isAfter(moment(item.endTime)) ? 'Завершен' : 'Тест'}
                      </div>
                    ) : (
                      <button onClick={() => history.push(`${match.url}/${item.id}`)} className="btn btn-primary w-100">
                        {moment().isAfter(moment(item.endTime)) ? 'Завершен' : 'Тест'}
                      </button>
                    )}
                  </div>
                  <div className="col">
                    {!moment().isAfter(moment(item.endTime)) ? (
                      <div
                        className="btn btn-light w-100"
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        data-bs-original-title={`Рейтинг будет доступен после ${moment(item.endTime).format('HH:mm')}`}
                        data-delay="0"
                      >
                        Рейтинг
                      </div>
                    ) : (
                      <button className="btn btn-light w-100" onClick={() => history.push(`${match.url}/${item.id}/rating`)}>
                        Рейтинг
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ContestList;
